<script>
    import { setVariable } from "@/utils";
    import BaseButton from "@main/packages/BaseButton";
    import TheSvgIcon from "@main/packages/TheSvgIcon";

    export default {
        name: "ModalAdult",
        components: {
            BaseButton,
            TheSvgIcon,
        },
        methods: {
            onConfirm() {
                this.$popup.close("modal-adult");
                setVariable("is_available_adult_sections", true);
            },
            onDismiss() {
                this.$router.push({ name: "Home" });
                this.$popup.close("modal-adult");
            },
        },
    };
</script>

<template>
    <div class="modal-adult">
        <div class="modal-adult__title">Ой-ой, раздел только для взрослых! 🙈</div>
        <div class="modal-adult__text">
            На&nbsp;эти гаджеты можно смотреть только после 18&nbsp;лет.
            <b>Кстати, их&nbsp;не&nbsp;увидит и&nbsp;курьер</b>. Продукты для взрослых
            мы&nbsp;отправляем в&nbsp;непрозрачной картонной упаковке
        </div>

        <the-svg-icon class="modal-adult__icon" name="status"></the-svg-icon>

        <div class="modal-adult__subtitle">Продолжить?</div>

        <div class="modal-adult__controls">
            <base-button class="modal-adult__button" @click="onConfirm">
                Да, мне есть 18
            </base-button>
            <base-button class="modal-adult__button" variant="v2" @click="onDismiss">
                Нет
            </base-button>
        </div>
    </div>
</template>

<style lang="scss">
    .modal-adult {
        text-align: center;
    }

    .modal-adult__title {
        margin-bottom: 24px;
        padding: 0 20px;
        font-size: 20px;
        line-height: 32px;
        font-weight: 600;
        @include bp($bp-desktop-sm) {
            font-size: 28px;
            line-height: 40px;
        }
    }

    .modal-adult__subtitle {
        margin-bottom: 24px;
        font-size: 18px;
        line-height: 24px;
        font-weight: 600;
        @include bp($bp-desktop-sm) {
            font-size: 24px;
            line-height: 36px;
        }
    }

    .modal-adult__text {
        margin-bottom: 24px;
        font-size: 16px;
        line-height: 24px;
        @include bp($bp-desktop-sm) {
            font-size: 20px;
            line-height: 28px;
        }
    }

    .modal-adult__icon {
        @include box(40px);
        fill: #adbdd2;
        @include bp($bp-desktop-sm) {
            @include box(80px);
        }
    }

    .modal-adult__controls {
        display: flex;
        justify-content: center;
        grid-gap: 10px;
        @include bp($bp-desktop-sm) {
            max-width: 400px;
            margin: 0 auto;
        }
    }

    .modal-adult__button {
        flex-grow: 1;
    }
</style>
